// components
import orContentMediaBlock from './or-content-media-block.variants';
import { AtDivider } from '@/components/atoms/at-divider/at-divider';

// types
import { EThemes } from '@/lib/contentstack-sdk/types';
import {
  EOrContentMediaBlockSize,
  IOrcontentMediaBlockProps,
} from './or-content-media-block.types';
import {
  EDividerColors,
  EDividerDirectionalVariants,
  EDividerVariants,
} from '@/components/atoms/at-divider/at-divider.types';

// utils + hooks
import { JSX } from 'react';
import classNames from 'classnames';

export const OrContentMediaBlock = ({
  theme = EThemes.LIGHT,
  children,
  size = EOrContentMediaBlockSize.SM,
  RenderLeftContent,
  topSpacing = 'md',
  bottomSpacing = 'md',
  topDivider = false,
  bottomDivider = false,
}: IOrcontentMediaBlockProps): JSX.Element => {
  const { base, leftColumn, rightColumn, media } = orContentMediaBlock({
    size,
    topSpacing,
    bottomSpacing,
  });
  return (
    <section data-theme={theme} data-testid="or-content-media-block">
      <div className={classNames('container w-full')}>
        {topDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
        <div
          className={classNames(
            base(),
            'mx-auto grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12',
          )}
        >
          <div className={classNames(leftColumn())}>
            <figure className={classNames(media())}>
              {RenderLeftContent()}
            </figure>
          </div>
          <div className={classNames(rightColumn())}>{children}</div>
        </div>
        {bottomDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
      </div>
    </section>
  );
};
